import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
export default {
  name: 'MdmStripe',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'small',
      validator: function validator(value) {
        return ['small', 'medium'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      staticClass: {
        stripe: true,
        rounded: true
      }
    };
  }
};